module.exports = __webpack_public_path__ + "static/media/diagram_05.3a93ea2b.svg";